import * as React from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import {useField} from "react-final-form";
import {
    SimpleForm,
    DateTimeInput,
    BooleanInput,
    Edit,
    TextInput,
    SelectInput,
    useRecordContext,
    Toolbar,
    SaveButton
} from "react-admin";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    makeStyles,
    Dialog,
    DialogTitle,
    Typography,
    DialogContent,
    Box,
    FormControlLabel,
    Checkbox, CircularProgress, DialogActions,
} from "@material-ui/core";
import API from "../../helpers/apiHelpers";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {setPetAge} from "../../utils/petInfo";
import {getAppointmentType, servicesObj} from "../../Constants/serviceType";
import {api_cancelOnBehalfOfUser} from "../../redux/appointment/appointment.api";
import {useHistory} from "react-router";
import {useSnackbar} from "notistack";
import {useCallback, useEffect, useState} from "react";
import {useDropzone} from "react-dropzone";
import {useAppDispatch} from "../../redux/store";
import {rhapsodyPetTypes} from "../../Constants/specialities";
import {
    getAppointmentNotes,
    getFollowUpByID,
    patchFollowUps,
    postFollowUps
} from "../../redux/appointment/appointment.actions";
import moment from "moment";
import RecordListItem from "../ListItems/RecordListItem";
import {colorInputBorderGrayish} from "../../Constants/theme";
import {MedicalRecordsModal} from "../index";
import {colorInputBorder} from "../../Constants/theme";

const statuses = [
    {id: "ACCEPTED", name: "Accepted"},
    {id: "REQUEST_MADE", name: "Request Made"},
    {id: "REJECTED", name: "Rejected"},
    {id: "CANCELLED", name: "Cancelled"}
];
const options = [
    {value: "GREAT", label: "Great"},
    {value: "IMPROVING", label: "Improving"},
    {value: "ABOUT_THE_SAME", label: "About the same"},
    {value: "GETTING_WORSE", label: "Getting worse"},
    {value: "OTHER", label: "Other"},
];

const AgeField = (props, {name, label}) => {
    const {
        input: {onChange},
        meta: {touched, error}
    } = useField(name);
    const record = useRecordContext(props);
    const age = setPetAge(record.appointment ? record.appointment.animal.dateOfBirth : record.animal.dateOfBirth);

    return <TextField disabled variant="filled" value={age} name={name} label="Pet Age" onChange={onChange}
        error={!!(touched && error)} helperText={touched && error} fullWidth/>;
};

const NameField = (props, {name}) => {
    const {
        input: {onChange},
        meta: {touched, error}
    } = useField(name);
    const record = useRecordContext(props);
    const user = record.userDetails?.ownerProfileDetails ? `${record.userDetails.ownerProfileDetails.firstName} ${record.userDetails.ownerProfileDetails.lastName}` : "";

    return <TextField disabled variant="filled" value={user} name={name} label="Client Name" onChange={onChange}
        error={!!(touched && error)} helperText={touched && error} fullWidth/>;
};
const TypeField = (props, {name}) => {
    const {
        input: {onChange},
        meta: {touched, error}
    } = useField(name);
    const record = useRecordContext(props);
    const user = record.userDetails.ownerProfileDetails?.partnerName ? record.userDetails.ownerProfileDetails?.partnerName : "The Video Vets";

    return <TextField disabled variant="filled" value={user} name={name} label="Client Type" onChange={onChange}
        error={!!(touched && error)} helperText={touched && error} fullWidth/>;
};

const AnimalTypeField = (props, {name}) => {
    const {
        input: {onChange},
        meta: {touched, error}
    } = useField(name);
    const record = useRecordContext(props);
    const animalType = rhapsodyPetTypes.find(el => el.value === record.animal?.type).label;

    return <TextField disabled variant="filled" value={animalType} name={name} label="Animal Type" onChange={onChange}
        error={!!(touched && error)} helperText={touched && error} fullWidth/>;
};

const DrField = (props, {name, label}) => {
    const {
        input: {onChange},
        meta: {touched, error}
    } = useField(name);
    const record = useRecordContext(props);
    const user = record.userDetails.vetProfileDetails ? `Dr. ${record.userDetails.vetProfileDetails.lastName}` : "";

    return <TextField disabled variant="filled" value={user} name={name} label="Vet Name" onChange={onChange}
        error={!!(touched && error)} helperText={touched && error} fullWidth/>;
};


const useStyle = makeStyles((theme) => ({
    uploadButton: {
        width: 270,
        marginLeft: 8,
        marginTop: 16,
        color: colorInputBorder,
        borderRadius: 6,
        border: `1.5px solid ${colorInputBorder}`,
        padding: "6px 16px",
        textAlign: "center",
        cursor: "pointer",
    },
    uploadButtonText: {
        color: colorInputBorder,
        fontWeight: "bold",
        fontSize: 16,
        marginTop: "3px"
    },
    cancelBtn: {
        width: 270,
        marginLeft: 8,
        marginTop: 16,
    },
    dialog: {
        padding: "48px 0 48px 25px",
        maxWidth: "1600px"
    },
    dialogNote: {
        padding: "30px 0 30px 25px",
        width: "900px"
    },
    textPlain: {
        fontSize: 18,
        whiteSpace: "nowrap",
    },
    button: {
        margin: "1.5em 1.5em 0 0",
        padding: "13px 28px",
    },
    actions: {
        paddingLeft: "24px"
    },
    itemDivider: {
        borderBottom: `1px solid ${colorInputBorderGrayish}`
    },
}));

const AppointmentEdit = (props) => {
    const classes = useStyle();
    const history = useHistory();
    const {enqueueSnackbar} = useSnackbar();
    const dispatch = useAppDispatch();
    const [expanded, setExpanded] = React.useState("general");
    const [state, setState] = useState("");
    const [openRecordsModal, setOpenRecordsModal] = useState(false);
    const [recordsList, setRecordsList] = useState(null);
    const [openNotesModal, setOpenNotesModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [vetProfiles, setVetProfiles] = useState(null);

    const getNotesForAppointment = async (id) => {
        const {
            userDetails: {vetProfileDetails},
            animal
        } = await API.getApointmentById(id);
        setIsLoading(true);
        setOpenRecordsModal(true);
        try {
            const records = await dispatch(getAppointmentNotes(
                {animalId: animal.id}
            ));
            setRecordsList(records);
            const vetId = Array.from(new Set(records.map(item => item.appointment.vetUserId)));
            const vets = await API.getProfiles({userId: vetId});
            setVetProfiles(vets);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const onCancel = async (id) => {
        const {
            id: apptId,
            userDetails: {ownerProfileDetails: {userId}}
        } = await API.getApointmentById(id);
        api_cancelOnBehalfOfUser(apptId, userId, {status: "CANCELLED"})
            .then(() => {
                enqueueSnackbar("Success!", {
                    variant: "success",
                    autoHideDuration: 4000
                });
                history.push("/appointments/search");
            }
            );
    };

    const onCancelByVet = async (id) => {
        const {
            id: apptId,
            userDetails: {vetProfileDetails: {userId}}
        } = await API.getApointmentById(id);
        api_cancelOnBehalfOfUser(apptId, userId, {status: "CANCELLED"})
            .then(() => {
                enqueueSnackbar("Success!", {
                    variant: "success",
                    autoHideDuration: 4000
                });
                history.push("/appointments/search");
            }
            );
    };
    const onDrop = useCallback(async (acceptedFiles) => {
        const appointment =  await API.getApointmentById(props.id);
        acceptedFiles.forEach((file) => {
            if (file.type !== "application/pdf") {
                enqueueSnackbar("Please, upload only PDF format!", {
                    variant: "error",
                    autoHideDuration: 4000
                });
                return;
            }
            const reader = new FileReader();
            reader.onload = async () => {
                const base64str = reader.result;
                if (typeof base64str !== "string") return;
                const binary = atob(base64str
                    .replace(/\s/g, "")
                    .replace("data:application/pdf;", "")
                    .replace("base64,", ""));
                const len = binary.length;
                const buffer = new ArrayBuffer(len);
                const view = new Uint8Array(buffer);
                for (let i = 0; i < len; i++) {
                    view[i] = binary.charCodeAt(i);
                }
                const blob = new Blob( [view], { type: "application/pdf" });

                const pdfParams = {
                    appointmentId: appointment.id,
                    clientId: appointment.userDetails.ownerProfileDetails.userId,
                    imageUrl: "",
                    created: moment.utc().format(),
                    vetId: appointment.userDetails.vetProfileDetails.userId,
                };
                const firstStep = await API.addConsentForm(pdfParams)
                    .then(res => res.json());
                if (firstStep.message) {
                    enqueueSnackbar(firstStep.message, {
                        variant: "error",
                        autoHideDuration: 4000
                    });
                    return;
                }
                const url = await API.getConsentURLs(firstStep.id);
                const sendImage = await API.uploadConsentForm(url.uploadUrl, blob);
                enqueueSnackbar("Success!", {
                    variant: "success",
                    autoHideDuration: 4000
                });
            };
            reader.readAsDataURL(file);
        });
    }, []);

    const {getRootProps, getInputProps} = useDropzone({onDrop});

    const SaveCustomButton = props => {
        return <SaveButton type="button" label={'Save'} {...props}/>;
    }

    const PostEditToolbar = props => (
        <Toolbar {...props}>
            <SaveCustomButton type="button"/>
        </Toolbar>
    );

    return (
        <Edit {...props}>
            <SimpleForm toolbar={<PostEditToolbar/>}>
                <Accordion expanded={expanded === "general"} onChange={handleChange("general")}
                    style={{width: "100%", marginBottom: 10}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="general"
                    >
                        Client and Appointment Info
                    </AccordionSummary>
                    <AccordionDetails>
                        <NameField source="userDetails" label="Client Name"/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TypeField source="userDetails.ownerProfileDetails.type" label="Client Type"/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.ownerProfileDetails.phoneNumber" label="Client Phone" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.ownerProfileDetails.email" label="Client Email" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <DrField source="userDetails" label="Vet Name"/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.vetProfileDetails.email" label="Vet Email" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <Grid container xs={12}>
                            <Grid container xs={6}>
                                <DateTimeInput source="scheduledDate" fullWidth/>
                            </Grid>
                            <Grid container xs={6}>
                                <TextField
                                    disabled
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    margin="dense"
                                    value={new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[0].slice(0,6) + ":" + new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[0].slice(6)}
                                    name="timezone"
                                    label="Time zone"/>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled multiline source="description" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="status"/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <SelectInput source="type" choices={servicesObj}/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <BooleanInput source="finished"/>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === "customerInfo"} onChange={handleChange("customerInfo")}
                    style={{width: "100%", marginBottom: 10}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel2a-content"
                        id="customerInfo"
                    >
                        Pet Info
                    </AccordionSummary>
                    <AccordionDetails>
                        <NameField source="userDetails.ownerProfileDetails.firstName" label="Client Name"/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.ownerProfileDetails.phoneNumber" label="Client Phone" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.ownerProfileDetails.email" label="Client Email" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.ownerProfileDetails.state" label="Client Location" initialValue={state} fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="animal.name" label="Pet Name" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <AnimalTypeField disabled source="animal.type" label="Pet Type" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="animal.weight" label="Pet Weight" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <AgeField source="animal.dateOfBirth" label="Pet Age"/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="animal.sex" label="Pet Sex" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="animal.pharmacyName" label="Pharmacy Name" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="animal.pharmacyPhone" label="Pharmacy Phone Number" fullWidth/>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === "vetInfo"} onChange={handleChange("vetInfo")}
                    style={{width: "100%", marginBottom: 10}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel3a-content"
                        id="vetInfo"
                    >
                        Vet Info
                    </AccordionSummary>
                    <AccordionDetails>
                        <DrField source="userDetails.vetProfileDetails.firstName" label="Vet Name" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.vetProfileDetails.phoneNumber" label="Vet Phone" fullWidth/>
                    </AccordionDetails>
                    <AccordionDetails>
                        <TextInput disabled source="userDetails.vetProfileDetails.email" label="Vet Email" fullWidth/>
                    </AccordionDetails>
                    <Dialog
                        open={openRecordsModal}
                        disableEnforceFocus
                        onClose={() => {
                            setOpenRecordsModal(false);
                            setRecordsList(null);
                        }}
                        classes={{paper: classes.dialogNote}}
                        scroll="body"
                    >
                        <DialogTitle color="primary">
                            <Typography variant="h3">
                                Medical Records
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            {isLoading ?
                                <Box width="100%" height="300px" display="flex" justifyContent="center" alignItems="center">
                                    <CircularProgress/>
                                </Box>
                                : (recordsList?.length && vetProfiles?.length) ?
                                    [...recordsList]
                                        .sort((a, b) => moment(b.created).diff(moment(a.created)))
                                        .map(({id, created, appointment}, idx) => {
                                            const vet = vetProfiles.find(profile => profile.userId === appointment?.vetUserId);
                                            const title = appointment.status === "NOT_APPLICABLE" ? "In-Clinic Appointment" : `${getAppointmentType(appointment?.type)} ${vet?.lastName? (`- Dr. ${vet.lastName}`) : ""}`;
                                            const noteCreated = moment(created).format("MMMM DD, YYYY");
                                            return <RecordListItem
                                                key={idx}
                                                id={id}
                                                title={title}
                                                date={noteCreated}
                                                isAdmin={true}
                                                setSelectedRecord={setSelectedRecord}
                                                setOpenModal={setOpenNotesModal}
                                                styles={(idx === recordsList.length - 1) ? "" : classes.itemDivider}
                                            />;
                                        })
                                    :
                                    <Typography variant="h6">No medical records</Typography>}
                        </DialogContent>
                        <DialogActions classes={{root: classes.actions}}
                        >
                            <Box display="flex" justifyContent="flex-start" width="100%">
                                <Button type="button"variant="contained"
                                    onClick={() => {
                                        setOpenRecordsModal(false);
                                        setRecordsList(null);
                                    }}>
                                    Close
                                </Button>
                            </Box>
                        </DialogActions>
                    </Dialog>
                    <MedicalRecordsModal isOpen={openNotesModal} setOpenDialog={setOpenNotesModal} noteId={selectedRecord}/>
                </Accordion>
                <div style={{flexDirection: "row", display: "flex", width: "100%"}}>
                    <Button type="button" variant="contained" className={classes.cancelBtn} onClick={() => onCancel(props.id)}>Cancel on behalf of parent</Button>
                    <Button type="button" variant="contained" className={classes.cancelBtn} onClick={() => onCancelByVet(props.id)}>Cancel on behalf of vet</Button>
                    <Button type="button" variant="contained" className={classes.cancelBtn} onClick={() => {
                        getNotesForAppointment(props.id);
                    }}>View Notes</Button>
                    <div {...getRootProps()} className={classes.uploadButton}>
                        <input {...getInputProps()} />
                        <Typography className={classes.uploadButtonText}>Upload Consent Form</Typography>
                    </div>
                </div>
            </SimpleForm>
        </Edit>
    );
};

export default AppointmentEdit;
